import Vue from 'vue'
import Router from 'vue-router'
import MenuView from '@/views/common/MenuView'
import PageView from '@/views/common/PageView'
// import LoginView from '@/views/login/Common'
import LoginView from '@/views/login/Login'
import EmptyPageView from '@/views/common/EmptyPageView'
import HomePageView from '@/views/HomePage'
import db from 'utils/localstorage'
import request from 'utils/request'
import PassengerInfo from '@/views/passenger/PassengerInfo/'
import FareSet from '@/views/fare/FareSet/'
import WarningDealInfo from '@/views/warning/WarningDealInfo/'
import ComplaintDealInfo from '@/views/complaint/ComplaintDealInfo/'
import SendOrderCarPool from '@/views/managers/SendOrderCarPool'
import SendOrder from '@/views/managers/SendOrder'
import orderDetail from '@/views/order/orderDetail'
import DriverComplateOrder from '@/views/driver/DriverComplateOrder'

Vue.use(Router)

//在这里设置路由，主要是为了页面跳转，其余路由在数据库设置
let constRouter = [
  {
    path: '/login',
    name: '登录页',
    component: LoginView
  },
  {
    path: '/index',
    name: '首页',
    redirect: '/home'
  },
  {
    path: '/passengerInfo',
    name: '乘客详情',
    component:PassengerInfo
  },
  {
    path: '/fareSet',
    name: '设置运价',
    component:FareSet
  },
  {
    path: '/warningDealInfo',
    name: '报警处理详情页',
    component:WarningDealInfo
  },
  {
    path: '/complaintDealInfo',
    name: '投诉处理详情页',
    component:ComplaintDealInfo
  },

  {
    path:'/managers',
    children:[
      { path: 'managers/sendOrder',
        name: '派单管理页',
        component:SendOrder
      },
      { path: 'managers/sendOrderCarPool',
        name: '城际拼车派单页',
        component:SendOrderCarPool
      }
    ]
  },
  {
    path: '/orderDetail',
    name: '订单详情页',
    component:orderDetail
  },
]

let router = new Router({
  routes: constRouter
})

const whiteList = ['/login']

let asyncRouter

// 导航守卫，渲染动态路由
router.beforeEach((to, from, next) => {
  if (whiteList.indexOf(to.path) !== -1) {
    next()
  }
  let token = db.get('USER_TOKEN')
  let user = db.get('USER')
  let userRouter = get('USER_ROUTER')
  if (token.length && user) {
    if (!asyncRouter) {
      if (!userRouter) {
        request.get(`menu/${user.username}`).then((res) => {
          asyncRouter = res.data
          save('USER_ROUTER', asyncRouter)
          go(to, next)
        })
      } else {
        asyncRouter = userRouter
        go(to, next)
      }
    } else {
      next()
    }
  } else {
    next('/login')
  }
})

function go (to, next) {
  asyncRouter = filterAsyncRouter(asyncRouter)
  router.addRoutes(asyncRouter)
  next({...to, replace: true})
 
}

function save (name, data) {
  localStorage.setItem(name, JSON.stringify(data))
}

function get (name) {
  return JSON.parse(localStorage.getItem(name))
}

function filterAsyncRouter (routes) {
  return routes.filter((route) => {
    let component = route.component
    if (component) {
      switch (route.component) {
        case 'MenuView':
          route.component = MenuView
          break
        case 'PageView':
          route.component = PageView
          break
        case 'EmptyPageView':
          route.component = EmptyPageView
          break
        case 'HomePageView':
          route.component = HomePageView
          break
        default:
          route.component = view(component)
      }
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children)
      }
      return true
    }
  })
}

function view (path) {
  return function (resolve) {
    import(`@/views/${path}.vue`).then(mod => {
      resolve(mod)
    })
  }
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js